import CloseSegmentGroupsMarkers from '@/components/Packaging/LayeredTimeline/segments/CloseSegmentGroupsMarkers';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingTimelineScale } from '@/redux/selectors/packagingSelectors';
import { selectTimelineSegments } from '@/redux/selectors/packagingTimelineSelectors';
import { DROPPABLE_TYPES, SegmentsTrayDroppableData } from '@/redux/slices/packagingSlice.types';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import styled from '@emotion/styled';
import React, { Fragment, useMemo } from 'react';
import { SEGMENT_CONTAINER_PADDING, SEGMENT_HEIGHT, TIMELINE_SIDES_PADDING } from '../constants';
import Segment from './segments/Segment';

interface Props {
  isHighlighted: boolean;
  isEditingTemplate?: boolean;
}

const SegmentsTray: React.FC<Props> = ({ isHighlighted, isEditingTemplate }) => {
  const segments = useAppSelector(selectTimelineSegments);
  const scale = useAppSelector(selectPackagingTimelineScale);
  const data: SegmentsTrayDroppableData = {
    type: DROPPABLE_TYPES.SEGMENTS_TRAY
  };
  const { setNodeRef } = useDroppable({
    id: DROPPABLE_TYPES.SEGMENTS_TRAY,
    data
  });

  const itemIds = useMemo(() => (segments || []).map((segment) => segment.draggableId), [segments]);

  return (
    <SegmentsDroppableArea ref={setNodeRef}>
      <SegmentsContainer isHighlighted={isHighlighted}>
        <SortableContext items={itemIds} strategy={horizontalListSortingStrategy}>
          {(segments || []).map((segment) => (
            <Fragment key={segment.draggableId}>
              <Segment segment={segment} scale={scale} isEditingTemplate={isEditingTemplate} />
            </Fragment>
          ))}
        </SortableContext>
        <CloseSegmentGroupsMarkers />
      </SegmentsContainer>
    </SegmentsDroppableArea>
  );
};

export default React.memo(SegmentsTray);

const SegmentsDroppableArea = styled.div`
  position: relative;
`;

const SegmentsContainer = styled.div<{ isHighlighted: boolean }>`
  min-height: ${SEGMENT_HEIGHT + SEGMENT_CONTAINER_PADDING * 2}px;
  min-width: calc(100vw - ${TIMELINE_SIDES_PADDING}px * 2);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: ${SEGMENT_CONTAINER_PADDING}px;
  background: ${({ theme, isHighlighted }) => (isHighlighted ? `${theme.palette.success.main}4a` : 'transparent')};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;
